export default __webpack_public_path__ + "static/media/materieprime-main-img.22b2d6d6.jpg";